export const TYPES = [
  {
    value: 'sms',
    label: 'СМС'
  },
  {
    value: 'email',
    label: 'Email'
  },
  // {
  //   value: 'push',
  //   label: 'Push'
  // }
];

export const PRIORITIES = [
  {
    value: 0,
    label: 'Стандартная/массовая рассылка информационных сообщений'
  },
  {
    value: 1,
    label: 'Используется для интерактивных смс типа запрос-ответ'
  },
  {
    value: 2,
    label: 'Отправка подтверждающего какое-либо действия сообщения'
  },
  {
    value: 3,
    label: 'Сообщение о тревоге/сигнализационном случае, рассылка о чрезвычайных случаях'
  }
];

export const CATEGORIES = [
  {
    value: 'internal',
    label: 'Бонусы'
  },
  {
    value: 'external',
    label: 'Партнеры'
  },
];

export const MAILING_CAMPAIGN_TYPES_FILTER = [
  {
    value: 'all',
    label: 'Все'
  },
  {
    value: 'external',
    label: 'Партнеры'
  },
  {
    value: 'internal',
    label: 'Бонусы'
  }
];

export const TEMPLATES_STATUS = [
  { label: 'Все', value: 'all' },
  { label: 'Создан', value: 'created' },
  { label: 'Активный', value: 'active' },
  { label: 'Архив', value: 'archive' }
];

export const MAILING_TYPES_FILTER = [
  {
    value: 'all',
    label: 'Все'
  },
  {
    value: 'sms',
    label: 'СМС'
  },
  {
    value: 'email',
    label: 'Email'
  },
  // {
  //   value: 'push',
  //   label: 'Push'
  // }
];

export const getMailingType = (type) => {
  switch (type) {
    case 'sms':
      return 'СМС';
    case 'email':
      return 'Email';
    // case 'push':
    //   return 'Push';
    default:
      return '';
  }
};
export const getMailingStatus = (status) => {
  switch (status) {
    case 'created':
      return 'Создан';
    case 'active':
      return 'Активный';
    case 'archive':
      return 'Архив';
    default:
      return status;
  }
};
export const getMailingColorStatus = (status) => {
  switch (status) {
    case 'Создана':
    case 'Создан':
    case 'created':
      return 'primary.main';
    case 'Активна':
    case 'Активный':
    case 'Одобрена':
    case 'active':
      return 'success.main';
    case 'archive':
    case 'Архив':
      return 'text.secondary';
    case 'На одобрении':
      return 'warning.main';
    case 'Доработка':
      return 'error.main';
  }
};
export const getMailingCampaignType = (type) => {
  switch (type) {
    case 'internal':
      return 'Бонусы';
    case 'external':
      return 'Партнеры';
    default:
      return '';
  }
};
